var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('PagesPath',{attrs:{"pathTitle":'درباره ثریا مارکت',"pathTitle1":'درباره ما ',"pathTo1":'/about-us'}}),(
      _vm.homeData &&
      _vm.homeData.settings &&
      _vm.homeData.settings.site &&
      _vm.homeData.settings.site.about_us_site
    )?_c('div',{staticClass:"container bg-white rounded px-4 py-4"},[_c('p',[_vm._v(_vm._s(_vm.homeData.settings.site.about_us_site))])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }